import React from 'react'
import { Button, Row, Col } from 'antd'
import compose from 'recompose/compose'
import { inject } from 'mobx-react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import localeGet from '~/App/utils/localeGet'

const ParticipantItem = ({ participant, i18n: { locale }, onOrderChange, isFirst, isLast, sortHandle }) => {
  const { _id, order, registrationId, profile, tickets } = participant
  const handleOrderUp = () => onOrderChange({ from: order, to: order - 1 })
  const handleOrderDown = () => onOrderChange({ from: order, to: order + 1 })
  return (
    <Row style={{ padding: '8px', background: 'white' }} type="flex" align="middle" gutter={18}>
      {/* <Col md={1}><Icon type="swap" style={{ transform: 'rotate(90deg)' }} /></Col> */}
      <Col xs={4} md={2}>{sortHandle} {order + 1}.</Col>
      <Col xs={20} md={1} style={{ textAlign: 'right' }}>
        <Button size="small" icon="up" disabled={isFirst} onClick={handleOrderUp} />
        <Button size="small" icon="down" disabled={isLast} onClick={handleOrderDown} />
      </Col>
      <Col xs={24} md={8}>{`${profile.firstName} ${profile.lastName}`}</Col>
      <Col xs={16} md={10}>
        {tickets.map(t => localeGet(t, 'ticketType.name', locale)).join(', ')}
      </Col>
      <Col xs={8} md={3} style={{ textAlign: 'right' }}>
        <Link to={`/reg/${registrationId}/edit?pId=${_id}`}>
          <Button icon="edit">
            <FormattedMessage id="app.edit" defaultMessage="Edit" />
          </Button>
        </Link>
      </Col>
    </Row>
  )
}

export default compose(
  inject('i18n')
)(ParticipantItem)



// WEBPACK FOOTER //
// ./src/App/components/ParticipantItem/ParticipantItem.js